import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FixedConvThirtyComponent } from './fixed-conv-thirty/fixed-conv-thirty.component';
import { FixedFHAThirtyComponent } from './fixed-fhathirty/fixed-fhathirty.component';
import { FixedFifteenComponent } from './fixed-fifteen/fixed-fifteen.component';
import { FixedVAThirtyComponent } from './fixed-vathirty/fixed-vathirty.component';
import { LoginComponent } from './login/login.component';
import { ProfileComponent } from './profile/profile.component';
import { RateCardsComponent } from './rate-cards/rate-cards.component';
import { RegisterComponent } from './register/register.component';
import { SliderCalcComponent } from './slider-calc/slider-calc.component';


const routes: Routes = [
  { path: '', redirectTo: 'index', pathMatch: 'full' },
  { path: 'rateCard',  component: RateCardsComponent },
  { path: 'FHA',  component: FixedFHAThirtyComponent },
  { path: 'Conv30',  component: FixedConvThirtyComponent },
  { path: 'Conv15',  component: FixedFifteenComponent },
  { path: 'VA',  component: FixedVAThirtyComponent },
  { path: 'login',  component: LoginComponent },
  { path: 'register',  component: RegisterComponent },
  { path: 'profile',  component: ProfileComponent },
  { path: 'slider',  component: SliderCalcComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
